import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { QuoteInclusonCalculationsMap } from "../../types/Calculation";

export const getQuoteInclusionCalculations = (quoteId: string) => {
  const { fetchWithAuth } = useApi();

  return useQuery({
    queryKey: ["quote-inclusion-calculations", quoteId],
    queryFn: (): Promise<QuoteInclusonCalculationsMap> => {
      return fetchWithAuth<QuoteInclusonCalculationsMap>(
        "getQuoteInclusionCalculations",
        quoteId
      );
    },
  });
};
